import styled from 'styled-components'
import { colors } from '../../../../../shared/styles/colors'

export const BreadCrumb = styled.div`
  display: flex;
  width: 100%;
  height: 41px;
  flex-direction: row;
  align-items: center;
  padding: 14px 30px;
  justify-content: space-between;
  background-color: ${colors.dashboard};
  z-index: 97;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`

export const ContainerCards = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-top: 12px;
  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.blue};
    border-radius: 70px;
  }
`

export const PageTitle = styled.div`
  font-family: Inter, 'Roboto', sans-serif;
  font-style: italic;
  font-size: 16px;
  font-weight: 700;
  color: ${colors.grayDark};
`
